import React from 'react';
import { Dumbbell, ArrowRight } from 'lucide-react';
import { gymImage } from '../../mock';

const Gym = () => {
  return (
    <section className="py-20 lg:py-28 bg-[var(--brand-cream-2)]">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-8 items-stretch">
          <div className="reveal relative rounded-[28px] overflow-hidden border border-[rgba(31,58,46,0.08)] min-h-[420px]">
            <img src={gymImage} alt="Elevate Wellness Gymnasium" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[rgba(31,58,46,0.65)] via-[rgba(31,58,46,0.2)] to-transparent" />
            <div className="absolute left-6 top-6">
              <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-[var(--brand-cream)] px-3 py-1.5 rounded-full bg-[rgba(0,0,0,0.35)] backdrop-blur border border-white/20">
                <span className="h-1.5 w-1.5 rounded-full bg-[var(--brand-gold-2)]" />
                Coming in 2026
              </span>
            </div>
          </div>

          <div className="reveal flex flex-col justify-center">
            <div className="h-11 w-11 rounded-full grid place-items-center bg-[var(--brand-green)] text-[var(--brand-cream)] mb-5">
              <Dumbbell size={18} strokeWidth={1.6} />
            </div>
            <div className="text-xs uppercase tracking-[0.24em] text-[var(--brand-gold)] mb-3">Coming Soon</div>
            <h2 className="font-serif text-4xl lg:text-5xl text-green tracking-tight leading-[1.05]">
              The Elevate <em className="italic">Wellness</em> Gymnasium.
            </h2>
            <p className="mt-5 text-[var(--brand-mute)] text-lg max-w-lg">
              A medically-led gymnasium integrating clinical diagnostics with expert-guided functional training. Designed by health professionals — for strength, longevity and life-long performance.
            </p>
            <div className="mt-8 flex flex-wrap gap-6">
              {[
                ['Precision', 'Data-driven programming'],
                ['Medical', 'Clinician-guided training'],
                ['Longevity', 'Built for the long game'],
              ].map(([k, v]) => (
                <div key={k} className="min-w-[140px]">
                  <div className="font-serif text-xl text-green">{k}</div>
                  <div className="text-sm text-[var(--brand-mute)]">{v}</div>
                </div>
              ))}
            </div>
            <a href="#book" className="btn-primary mt-8 self-start text-sm">
              Join the waitlist <ArrowRight size={16} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gym;
